import React, { useState } from "react";
import Header from "components/Header/Header";
import { ClearCartIcon, LeftArrowIcon } from "constants/icons";
import { APP_ROUTES } from "constants/routes";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import AlertModal from "components/AlertModal/AlertModal";
import useCart from "hooks/useCart";

//Shows cart title and clear cart icon.
function CartHeader({ componentTexts }) {
  const [showClearModal, setShowClearModal] = useState(false);
  const { currentCartItems, clearCart } = useCart();

  const toggleCartClearModal = function () {
    return setShowClearModal(!showClearModal);
  };

  const clearCartHandler = function () {
    toggleCartClearModal();

    return clearCart();
  };

  return (
    <React.Fragment>
      <Header className="cart-page__header">
        <div className="cart-page__page-title">
          <Link to={APP_ROUTES.HOME_PAGE.url}>
            <i>
              <LeftArrowIcon />
            </i>
          </Link>
          <span>{componentTexts.cart_page_title}</span>
        </div>
        {currentCartItems.length > 0 && (
          <div>
            <i onClick={toggleCartClearModal} className="cursor--pointer">
              <ClearCartIcon />
            </i>
          </div>
        )}
      </Header>
      <AlertModal
        open={showClearModal}
        modalTitle={componentTexts.clear_cart_popup.clear_cart_popup_title}
        modalDescription={
          componentTexts.clear_cart_popup.clear_cart_popup_description
        }
        closeHandler={toggleCartClearModal}
        submitHandler={clearCartHandler}
      />
    </React.Fragment>
  );
}

CartHeader.propTypes = {
  componentTexts: PropTypes.object.isRequired,
};

export default CartHeader;
